import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SpsCustomIconComponent } from '../sps-custom-icon/sps-custom-icon.component';

@Component({
  selector: 'sps-payment-method-icon-text',
  imports: [
    NgClass,
    SpsCustomIconComponent
  ],
  templateUrl: './sps-payment-method-icon-text.component.html'
})
export class SpsPaymentMethodIconTextComponent {

  @Input() icon: string;
  @Input() customIcon: boolean;
  @Input() text: string;

}
